<template>
  <div class="container">
    <div class="goBackBtn" @click="$router.go(-1)">
      <h2>
        X
      </h2>
    </div>
    <div id="privacy-policy" class="privacy-policy" v-html="privacy"></div>
  </div>
</template>

<script>
import Axios from 'axios';
import { mapActions } from "vuex";
export default {
  name: "Politics",
  props: {
    name: {
      type: String,
      default: "cuamoc.com.mx",
    },
  },
  data(){
    return {
      privacy:'',  
    }
  },
  async mounted(){
    window.scrollTo(0,0)
    let serviceResponse = await Axios.get('https://api-mx-marketing.azure-api.net/sitios/privacidad/aviso')
    this.privacy = serviceResponse.data.replace('{', '').replace('"body":"', '').replace(`";
        }`,'')
  },
  async beforeRouteLeave() {
    this.setAgeGateTokenAction(false)
    location.reload()
  },
  methods: {
    ...mapActions({
      setAgeGateTokenAction: "setAgeGateToken",
    }),
  }
};
</script>
<style lang="scss" >
@import "~@/styles/variables.scss";
.goBackBtn {
  display: flex;
  flex-direction: row;
  //width: 130px;
  width: 80px;
  background-color: transparent;
  border: none;
  color: $black;
  font-family: $font-Dunbar-Light;
  //margin-left: 2rem;
  font-size: 1.4vw;
  float: right;
  position: absolute;
  top: 0px;
  right: 0px;
  h2 {
    color: $black !important;
    margin-inline: 0;
  }
  @media screen and (max-width: 768px) {
    //width: 80px;
    width: 42px;
    h2 {
      font-size: 4.8vw;
    }
  }
}
.goBackBtn:hover {
  cursor: pointer;
}

.privacy-policy {
  padding-inline: 2vw;
  font-family: 'DunbarTall-Light' !important;
  font-size: 1.7vw !important;
  margin-right: 4.2pt !important;
  margin-left: 0.2pt !important;
  color: $black !important;
  margin-top: 7vw !important;
  h2 {
    margin-bottom: 2vw !important;
  }
  h3,
  p {
    margin: 0;
    margin-bottom: 0pt !important;
  }
  @media (max-width: 768px) {
    font-size: 5.5vw !important;
    margin-right: 2.2pt !important;
    margin-left: 2.2pt !important;
    //margin-top: 20vw !important;
    h2 {
      margin-bottom: 5vw !important;
    }
    a {
      @media (max-width: 768px) {
        overflow: hidden;
        display: flex;
      }
    }
  }
}
</style>
